import uiReducer from "./ui";

const reducers = [
    uiReducer
];

export default (state, action) => {
    var _state = state;

    reducers.forEach((reducer) => {
        _state = reducer(_state, action);
    })

    return _state;
}